var createHubLocale = require('./localeFactory.js')
var backgroundRemoverLocales = require('./backgroundRemoverLocales.js')
var portraitChangerLocales = require('./portraitChangerLocales.js')
var bgPack = backgroundRemoverLocales.ko
var pcPack = portraitChangerLocales.ko

var ARTICLE_BODIES = Object.assign({}, {
  'seedream-ai-image-generator-review': {
    overview: [
      'Seedream은 아트 중심 모델에서 흔히 보이는 즉각적인 스타일화가 아니라, 사실적인 상업용 비주얼을 위해 설계되었습니다. Seedream 5로 브라우저에서 온라인 생성할 수 있으며 Discord나 Stable Diffusion 로컬 설치가 필요 없습니다.',
      '저는 빠른 레이아웃 도구로 사용합니다. 제품 배치, 조명, 배경 방향은 보통 몇 버전 만에 명확해집니다. 유리 반사나 금속 가장자리를 더 선명하게 원할 때는 같은 브리프를 FLUX에서 다시 실행합니다.',
      'Midjourney와 비교하면 Seedream은 판타지 분위기보다 제품 + 장면 + 조명 같은 상업용 프롬프트를 따릅니다. GPT Image와 비교하면 이미지 안의 긴 헤드라인 텍스트보다 비주얼 장면이 더 강합니다. 이커머스 히어로 이미지와 라이프스타일 포스터가 시작하기 가장 쉬운 용도입니다.'
    ],
    practice: [
      '이 리뷰에서는 30ml 스킨케어 병을 Amazon 메인 이미지, Instagram 4:5 제품 게시물, 깔끔한 SKU 샷으로 테스트했습니다. 각 라운드마다 5~6개 버전을 생성해 바로 쓸 수 있는 것과 프롬프트 수정이 필요한 것을 확인했습니다.',
      '유용한 패턴은 단순했습니다. 방향은 Seedream, 클라이언트가 유리와 금속 디테일을 중시하면 마무리는 FLUX, 읽기 쉬운 프로모 텍스트가 필요한 납품물은 GPT Image입니다.'
    ],
    compareIntro: '유일한 최고 모델은 없고, 작업에 맞는 것만 있습니다. 기본 스택은 상업용 제품 비주얼에 Seedream, 하드한 제품 사진에 FLUX, 아트 탐색에 Midjourney, 텍스트가 많은 포스터에 GPT Image입니다.',
    modelFaq: [
      { q: 'Seedream으로 이커머스 제품 이미지를 만들려면?', a: '제품 + 장면 + 조명 + 용도를 적으세요. Amazon 메인 이미지는 먼저 깔끔한 버전을 몇 장 만든 뒤 소재와 배경을 다듬습니다.' },
      { q: 'Seedream을 Amazon 메인 이미지에 쓸 수 있나요?', a: '예. 흰색이나 밝은 배경은 가능하지만 가장자리 정리는 보통 3~4버전이 필요합니다. 라이프스타일 장면이 더 빨리 잡히는 편입니다.' },
      { q: 'Seedream으로 Shopify 라이프스타일 이미지를 만들 수 있나요?', a: '예. 배너는 16:9, 브랜드 색, 첫 화면 구도를 프롬프트에 넣고, 제품 타일은 1:1을 사용하세요.' },
      { q: '이커머스 히어로 이미지를 만들 AI 도구는?', a: '상업 장면은 Seedream으로 시작하세요. 더 하드한 유리·금속이 필요하면 FLUX, 읽기 쉬운 프로모 텍스트가 필요하면 GPT Image로 전환합니다.' },
      { q: 'Seedream 생성에서 제품 디테일이 틀리면 어떻게 고치나요?', a: '브리프를 짧게 하고 제품 설명을 고정한 뒤 다시 생성하세요. 소재가 여전히 부드러우면 같은 구도를 FLUX로 마무리합니다.' },
      { q: 'Seedream 5와 Seedream 4의 차이는?', a: '일상적인 상업 작업에서는 프롬프트 스타일이 비슷합니다. 새 작업에는 Seedream 5를 쓰고, Seedream 4에 맞춘 기존 프로젝트는 강제 이전할 필요가 없습니다.' },
      { q: 'Seedream으로 포스터 헤드라인을 바로 생성할 수 있나요?', a: '긴 프로모 헤드라인은 Seedream으로 베이스 비주얼을 만들고 GPT Image로 텍스트 레이아웃을 합니다. 한 번에 맞추는 것보다 이 분업이 더 안정적입니다.' },
      { q: 'Discord가 필요한가요?', a: '아니요. Seedream, FLUX, Midjourney, GPT Image는 모두 Miral 브라우저에서 테스트할 수 있습니다.' }
    ]
  },
  'flux-ai-image-generator-review': {
    overview: [
      'FLUX는 납품물에 하드한 제품 사진이 필요할 때—금속 반사, 유리, 피부 텍스처, 광고형 조명—손이 가는 모델입니다. FLUX.2가 일상의 주력이고 Flux Schnell은 빠른 구도 테스트용입니다.',
      '보통 Seedream과 함께 씁니다. Seedream으로 구도를 빠르게 고정한 뒤 FLUX로 재질과 빛을 다듭습니다. 일러스트 중심 아트 방향은 FLUX를 아트 모델처럼 억지로 쓰지 않고 Midjourney나 Stable Diffusion으로 전환합니다.',
      '이미지 안에 읽기 쉬운 프로모 카피가 포함되면 GPT Image가 더 안전합니다. 클라이언트가 사진 품질을 볼 때 FLUX가 이깁니다.'
    ],
    compareIntro: '하드한 제품 사진과 광고 비주얼에는 FLUX.2, 더 빠른 장면 반복에는 Seedream, 컨셉 아트에는 Midjourney, 포스터에 명확한 텍스트가 필요하면 GPT Image를 사용하세요.',
    modelFaq: [
      { q: 'FLUX로 제품 사진을 만들려면?', a: '렌즈, 림 라이트, 재질, 하드한 제품 조명 같은 사진 언어를 쓰세요. 최종을 정하기 전에 몇 버전을 생성합니다.' },
      { q: 'FLUX를 상업용 제품 이미지에 쓸 수 있나요?', a: '예. 클라이언트가 사진 품질을 볼 때 금속, 유리, 광고형 조명에 강합니다.' },
      { q: 'FLUX로 사실적인 주얼리 사진을 만들 수 있나요?', a: '예. 짧은 프롬프트만으로는 부족합니다. 매크로, 가장자리 빛, 배경, 재질 디테일을 넣고 구도 속도는 Seedream과 비교하세요.' },
      { q: '하드 라이트 제품 사진을 만들 AI 도구는?', a: '최종 텍스처는 FLUX.2. 장면을 더 빨리 반복하려면 먼저 Seedream으로 구도를 스케치하세요.' },
      { q: 'FLUX 생성에서 재질·반사가 부드러우면 어떻게 고치나요?', a: '더 날카로운 재질·조명 표현을 넣고 몇 버전을 다시 만든 뒤, 납품은 Flux Schnell이 아니라 FLUX.2를 사용하세요.' },
      { q: 'FLUX.2 vs Flux Schnell?', a: '구도 스크리닝은 Schnell. 납품에 가까워져 최종 재질 품질이 필요하면 FLUX.2입니다.' },
      { q: 'FLUX로 포스터 텍스트를 처리할 수 있나요?', a: '짧은 텍스트는 가능하지만 헤드라인 레이아웃과 읽기 쉬운 프로모 카피에는 GPT Image가 더 안정적입니다.' }
    ]
  },
  'midjourney-alternative-online': {
    overview: [
      'Midjourney 대안을 찾는 사람은 보통 세 가지 중 하나를 원합니다. Discord 없는 브라우저 접근, 더 매끄러운 웹 워크플로, 또는 아트 탐색과 이커머스 결과를 섞는 하나의 프로젝트입니다.',
      'Midjourney는 컨셉 아트, 판타지 장면, 스타일 탐색에 여전히 강합니다. Amazon 히어로 이미지, 하드한 제품 사진, 읽기 쉬운 텍스트 포스터는 같은 Miral 워크스페이스에서 Seedream, FLUX, GPT Image로 전환합니다.',
      'Stable Diffusion 3.5 online도 로컬 설치 없이 일러스트 제어를 원할 때 유용한 비교 대상입니다. 실무 흐름은 Midjourney나 Stable Diffusion으로 방향을 잡고 상업용 최종본은 Seedream이나 FLUX로 넘기는 경우가 많습니다.'
    ],
    compareIntro: '작업에 맞추기: 아트 탐색은 Midjourney, 빠른 상업 장면은 Seedream, 제품 사진은 FLUX, 텍스트 포스터는 GPT Image, 온라인 일러스트 제어는 Stable Diffusion 3.5.',
    modelFaq: [
      { q: 'Discord 없이 Midjourney를 온라인으로 쓰려면?', a: 'Miral 브라우저 워크플로에서 Midjourney를 열고 거기서 몇 버전을 생성하세요. 그 경로에는 Discord 봇 설정이 필요 없습니다.' },
      { q: '브라우저에서 Midjourney를 쓸 수 있나요?', a: '예. 설정 단계를 줄이고 나란히 비교를 빠르게 하려는 사람들이 Midjourney 대안을 찾는 주된 이유입니다.' },
      { q: 'Discord 없이 Midjourney 스타일 아트를 만들 수 있나요?', a: '예. 분위기는 브라우저 Midjourney로 잡고, 같은 프로젝트에 상업 제품 최종본이 필요하면 Seedream이나 FLUX로 전환하세요.' },
      { q: 'Discord 없이 이커머스 이미지를 만들 도구는?', a: '제품 장면은 Seedream, 하드한 제품 사진은 FLUX, 읽기 쉬운 프로모 텍스트가 필요하면 GPT Image입니다.' },
      { q: 'Midjourney 대안 사용 중 아트 스타일이 틀리면 어떻게 고치나요?', a: '한 모델에 모든 요구를 맡기지 마세요. 아트 방향은 Midjourney나 Stable Diffusion, 상업 최종본은 Seedream이나 FLUX로 옮깁니다.' },
      { q: 'Midjourney vs Stable Diffusion?', a: '둘 다 아트 탐색에 쓸 수 있습니다. Midjourney는 분위기에서, Stable Diffusion은 선과 스타일 제어에서 강한 경우가 있습니다.' }
    ]
  },
  'gpt-image-generator-guide': {
    overview: [
      'GPT Image는 납품물에 읽기 쉬운 텍스트 구조가 필요할 때—프로모 포스터, 제품 혜택 그래픽, 뉴스레터 헤더, 헤드라인 카피가 있는 소셜 커버—첫 선택입니다.',
      '가장 많이 쓰는 워크플로는 Seedream이나 FLUX로 제품 비주얼을 만든 뒤 GPT Image로 텍스트 레이아웃을 하는 것입니다. 사진과 타이포그래피를 한 번에 맞추는 것보다 이 분업이 더 안정적입니다.',
      '순수 아트 탐색이나 하드한 제품 사진에는 Midjourney, Seedream, FLUX가 여전히 더 낫습니다. GPT Image는 카피와 레이아웃이 창의적 요구의 일부일 때 이깁니다.'
    ],
    compareIntro: '텍스트 포스터와 혜택 그래픽에는 GPT Image, 큰 마케팅 키 비주얼에는 Qwen Image, 빠른 제품 장면에는 Seedream, 베이스 이미지에 하드한 사진이 필요하면 FLUX를 사용하세요.',
    modelFaq: [
      { q: 'GPT Image로 텍스트 포스터를 만들려면?', a: '헤드라인, 부제, 오퍼, 스타일, 종횡비를 먼저 쓰세요. 카피 블록을 짧게 유지해 레이아웃이 읽기 쉽게 합니다.' },
      { q: 'GPT Image를 Shopify 배너에 쓸 수 있나요?', a: '예. 헤드라인, 할인, 제품명, 브랜드 색, 16:9 비율을 프롬프트에 넣고 레이아웃 버전을 몇 개 생성하세요.' },
      { q: 'AI 이미지에 읽기 쉬운 텍스트를 만들 수 있나요?', a: '예, GPT Image로 가능합니다. 긴 문단이나 촘촘한 법적 문구보다 짧고 구조화된 프로모 카피가 더 잘 됩니다.' },
      { q: '제품 혜택 그래픽을 만들 AI 도구는?', a: '텍스트 레이아웃은 GPT Image. 사진 품질이 중요하면 먼저 Seedream이나 FLUX로 제품 장면을 만드세요.' },
      { q: 'GPT Image 포스터에서 철자가 틀리면 어떻게 고치나요?', a: '카피를 짧게 하고 다시 생성한 뒤 납품 전 모든 단어를 확인하세요. 비주얼은 맞고 텍스트만 실패하면 베이스 이미지를 남기고 타이포그래피만 다시 만듭니다.' },
      { q: 'GPT Image가 제품 사진을 대체할 수 있나요?', a: '완전히는 아닙니다. 제품 장면은 Seedream이나 FLUX로 생성하고 GPT Image에서 텍스트를 추가합니다.' }
    ]
  },
  'qwen-image-generator-review': {
    overview: [
      'Qwen Image 2.0 Pro는 더 큰 마케팅 비주얼—캠페인 포스터, 상세 페이지 히어로 이미지, 강한 중심 비주얼의 고해상도 소셜 커버—가 필요할 때 유용합니다.',
      '시각적 임팩트와 읽기 쉬운 텍스트 레이아웃 중 무엇이 중요한지에 따라 GPT Image와 비교합니다. Qwen Image는 큰 포스터 구도에서, GPT Image는 구조화된 프로모 카피에서 이기는 경우가 많습니다.',
      '제품 사진 최종본은 FLUX로, 빠른 이커머스 장면 초안은 속도가 더 중요하면 Seedream부터 시작합니다.'
    ],
    compareIntro: '큰 마케팅 포스터와 고해상도 키 비주얼에는 Qwen Image, 텍스트가 많은 프로모 레이아웃에는 GPT Image, 빠른 제품 장면에는 Seedream, 하드한 제품 사진에는 FLUX를 사용하세요.',
    modelFaq: [
      { q: 'Qwen Image로 고해상도 포스터를 만들려면?', a: '제품이나 캠페인 주제, 메인 헤드라인, 무드, 출력 크기를 쓰세요. Qwen Image는 큰 마케팅 키 비주얼에 가장 강합니다.' },
      { q: 'Qwen Image를 이커머스 상세 페이지에 쓸 수 있나요?', a: '예. 특히 강한 히어로 비주얼과 2K 수준 마케팅 이미지가 필요할 때 적합합니다.' },
      { q: 'Qwen으로 2K 마케팅 이미지를 생성할 수 있나요?', a: '예. 해상도 목표와 종횡비를 브리프에 넣고 게시 전 텍스트 가장자리를 확인하세요.' },
      { q: '큰 캠페인 포스터를 만들 AI 도구는?', a: '큰 포스터 임팩트는 Qwen Image. 구조화된 프로모 카피가 시각적 스케일보다 중요하면 GPT Image로 전환하세요.' },
      { q: 'Qwen Image 포스터에서 텍스트가 안 읽히면 어떻게 고치나요?', a: '헤드라인을 짧게 하고 작은 본문을 줄인 뒤 다시 생성하세요. 긴 혜택 목록은 GPT Image에서 텍스트 레이아웃을 마무리합니다.' },
      { q: 'Qwen Image vs FLUX?', a: '큰 캠페인 비주얼은 Qwen Image. 하드한 제품 사진과 재질 디테일은 FLUX입니다.' }
    ]
  },
  'z-image-ai-generator-review': {
    overview: [
      'Z Image Turbo는 최종 납품 모델이 아니라 방향을 찾는 모델입니다. 광고 구도, 색 방향, 소셜 프로모 레이아웃을 빠르게 테스트하는 데 씁니다.',
      '방향이 명확해지면 최종 상업 비주얼은 FLUX나 Seedream으로 넘깁니다. 읽기 쉬운 프로모 텍스트가 필요하면 GPT Image가 마지막 단계를 더 안정적으로 처리합니다.',
      'Flux Schnell과 비교하면 Z Image Turbo는 프로모 초안과 캠페인 색 테스트에 유용합니다. Midjourney와 비교하면 아트 탐색보다 빠른 상업 반복에 가깝습니다.'
    ],
    compareIntro: '방향을 빠르게 테스트하려면 Z Image Turbo, 최종 제품 사진에는 FLUX, 빠른 이커머스 장면에는 Seedream, 읽기 쉬운 텍스트가 필요한 프로모에는 GPT Image를 사용하세요.',
    modelFaq: [
      { q: 'Z Image Turbo로 빠른 광고 콘셉트를 만들려면?', a: '먼저 구도와 색 방향 3~5안을 생성하세요. 최종 납품 모델이 아니라 초안 모델로 다루세요.' },
      { q: 'Z Image Turbo를 소셜 미디어 광고에 쓸 수 있나요?', a: '방향 탐색과 캠페인 색 테스트에는 예. 중요한 라이브 자산은 FLUX나 Seedream으로 마무리하세요.' },
      { q: 'Z Image로 캠페인 초안을 생성할 수 있나요?', a: '예. 최종 재질 디테일보다 속도가 중요할 때 유용합니다.' },
      { q: '광고 구도를 빠르게 테스트할 AI 도구는?', a: '프로모 초안은 Z Image Turbo. 제품 사진 최종본은 FLUX, 읽기 쉬운 프로모 텍스트가 필요하면 GPT Image로 옮기세요.' },
      { q: 'Z Image 초안에서 제품 디테일이 약하면 어떻게 고치나요?', a: '마음에 든 구도를 고정한 뒤 같은 브리프로 최종본을 FLUX나 Seedream에서 다시 생성하세요.' },
      { q: 'Z Image Turbo vs Midjourney?', a: '아트 탐색은 Midjourney. 빠른 광고와 소셜 프로모 방향은 Z Image Turbo입니다.' }
    ]
  },
  'stable-diffusion-online-generator': {
    overview: [
      'Stable Diffusion 3.5 online은 모델 설치, GPU 관리, 로컬 ComfyUI 워크플로 구축 없이 일러스트형 제어를 원할 때 실용적인 선택입니다.',
      '아트 탐색, 캐릭터 디자인, 스타일화 일러스트에서 Midjourney와 자주 비교됩니다. 이커머스 제품 최종본은 스타일 방향이 명확해지면 Seedream이나 FLUX로 전환하는 경우가 많습니다.',
      '프로젝트에 읽기 쉬운 프로모 텍스트나 하드한 제품 사진도 필요하면 Stable Diffusion이 비주얼 방향을 정해도 최종 단계는 GPT Image와 FLUX가 더 낫습니다.'
    ],
    compareIntro: '일러스트와 스타일 제어에는 Stable Diffusion 3.5 online, 분위기 중심 아트 탐색에는 Midjourney, 빠른 상업 장면에는 Seedream, 제품 사진 최종본에는 FLUX를 사용하세요.',
    modelFaq: [
      { q: '설치 없이 Stable Diffusion을 온라인으로 쓰려면?', a: '브라우저의 온라인 SD 3.5 워크플로를 사용하세요. 첫 테스트에 로컬 모델, GPU 설정, ComfyUI가 필요 없습니다.' },
      { q: '로컬 GPU 없이 Stable Diffusion을 쓸 수 있나요?', a: '예. 일러스트와 캐릭터 방향용 온라인 경로의 주된 이점입니다.' },
      { q: '브라우저에서 SD 3.5를 실행할 수 있나요?', a: '예. 온라인으로 스타일 테스트를 몇 장 만든 뒤, 필요하면 상업 제품 최종본은 Seedream이나 FLUX로 옮기세요.' },
      { q: 'ComfyUI 없이 일러스트를 만들 AI 도구는?', a: '일러스트와 스타일 제어는 Stable Diffusion 3.5 online. 선 제어보다 분위기가 중요하면 Midjourney를 사용하세요.' },
      { q: 'Stable Diffusion 생성에서 캐릭터 디테일이 흔들리면 어떻게 고치나요?', a: '버전마다 정체성 표현을 짧고 안정적으로 유지하세요. 상업 최종본에 더 하드한 사진이 필요하면 스타일 방향 승인 후 FLUX로 전환합니다.' },
      { q: 'SD가 이커머스에서 Seedream을 대체할 수 있나요?', a: '최종 제품 사진은 Seedream이나 FLUX를 선호합니다. SD는 일러스트와 컨셉 방향에 더 적합합니다.' }
    ]
  },
  'ai-watermark-remover-online': {
    overview: [
      'AI Watermark Remover( AI 워터마크 제거 )는 이커머스나 디자인 작업에서 재사용하기 전에 소스 이미지에 로고, 코너 마크, 날짜 스탬프, 반복 오버레이 텍스트가 남아 있을 때 첫 정리 단계입니다.',
      '정리 후 같은 자산은 Seedream이나 FLUX로 새 제품 비주얼로, 읽기 쉬운 텍스트가 있는 프로모 레이아웃이 필요하면 GPT Image로 이어갈 수 있습니다.',
      '문서 중심 워크플로에서는 Image Crop & Dewarp( 문서 보정 )과 Handwriting Eraser( 손글씨 제거 )와 자주 함께 씁니다. 스캔을 먼저 바르게 한 뒤 필요하면 손글씨를 제거하고 OCR이나 재사용 전 워터마크를 제거합니다.'
    ],
    compareIntro: '기존 자산 정리에는 AI Watermark Remover( AI 워터마크 제거 )를 쓰고, 다음 단계에 따라 Image Crop & Dewarp, Handwriting Eraser, Seedream, FLUX, GPT Image로 이어갑니다.',
    toolFaq: [
      { q: '이커머스 이미지에서 워터마크를 지우려면?', a: '선명한 제품 사진을 올리고 워터마크나 로고 영역만 표시한 뒤 내보내기 전에 가장자리를 확인하세요.' },
      { q: 'Shopify 제품 사진에서 로고를 지울 수 있나요?', a: '예. 소스 이미지에 대한 권리가 있을 때입니다. 리스팅 전에 정리 후 제품 가장자리를 검사하세요.' },
      { q: '투명 워터마크도 이미지에서 지울 수 있나요?', a: '많은 코너 마크와 반복 오버레이는 가능합니다. 크고 대비가 낮은 워터마크는 두 번째 패스가 필요할 수 있습니다.' },
      { q: 'Shopify 이미지의 코너 마크를 지울 도구는?', a: '먼저 AI Watermark Remover. 새 제품 비주얼은 Seedream이나 FLUX로, 위에 프로모 텍스트가 필요하면 GPT Image로 이어가세요.' },
      { q: '워터마크 제거 후 텍스처가 반복되면 어떻게 고치나요?', a: '선택 영역을 더 좁히고 두 번째 정리 패스를 실행하세요. 첫 선택에서 중요한 제품 가장자리를 덮지 마세요.' },
      { q: 'Miral 도구를 하나의 워크플로로 결합할 수 있나요?', a: '예. 일반적인 순서는 Image Crop & Dewarp, Handwriting Eraser, AI Watermark Remover, 그다음 이미지 생성입니다.' }
    ]
  },
  'handwriting-eraser-online': {
    overview: [
      'Handwriting Eraser( 손글씨 제거 )는 인쇄 내용은 유지하면서 손글씨 표시를 제거해야 하는 스캔 워크시트, 계약서, 메모, 시험지용입니다.',
      '순서가 중요합니다. 스캔이 기울거나 구부러졌으면 보통 Image Crop & Dewarp( 문서 보정 )을 먼저 실행하고, Handwriting Eraser, 소스에 오버레이 마크가 남아 있을 때만 AI Watermark Remover( AI 워터마크 제거 )입니다.',
      '정리 후 파일은 OCR, 아카이브, 또는 Seedream, FLUX, GPT Image로 새 비주얼이 필요한 디자인 워크플로에서 재사용하기 쉬워집니다.'
    ],
    compareIntro: 'Image Crop & Dewarp( 문서 보정 )으로 문서를 바르게 한 뒤 Handwriting Eraser( 손글씨 제거 )를 쓰고, AI Watermark Remover, OCR, Seedream, FLUX, GPT Image 이미지 생성으로 이어갑니다.',
    toolFaq: [
      { q: '스캔 문서에서 손글씨 메모를 지우려면?', a: '선명한 스캔이나 사진을 올리고 손글씨 영역만 지정하세요. 표나 양식 선 주변은 작은 구역으로 나누어 처리합니다.' },
      { q: '인쇄된 글자는 남기고 손글씨만 지울 수 있나요?', a: '손글씨가 인쇄 내용과 심하게 겹치지 않으면 가능합니다. 내보내기 전에 작은 글자와 선 가장자리를 확인하세요.' },
      { q: '온라인에서 시험지 답안을 지울 수 있나요?', a: '예. Handwriting Eraser는 인쇄된 문제를 읽기 쉽게 유지하면서 학생 답안과 주석을 지우는 데 유용합니다.' },
      { q: '워크시트 손글씨 자국을 정리할 도구는?', a: '스캔이 기울어졌으면 먼저 Image Crop & Dewarp, 그다음 Handwriting Eraser. 오버레이 스탬프가 남을 때만 AI Watermark Remover로 이어가세요.' },
      { q: '손글씨 제거 후 글자가 흐려지면 어떻게 고치나요?', a: '넓은 선택을 취소하고 더 작은 영역으로 처리하세요. 마스크를 손글씨에 가깝게 두면 인쇄 문자가 선명하게 유지됩니다.' },
      { q: '손글씨 제거 후 인쇄 선이 끊기면 어떻게 고치나요?', a: '표 선과 양식 테두리를 마스크로 덮지 마세요. 밀집된 주석 주변은 더 작은 패스로 작업합니다.' }
    ]
  },
  'image-crop-dewarp-online': {
    overview: [
      'Image Crop & Dewarp( 문서 보정 )는 OCR이나 정리 전에 스캔 문서 이미지를 자동으로 자르고 기울기를 보정하며, 페이지 자체가 휜 경우에는 곡면 보정을 제공합니다.',
      '바르게 하고 자른 뒤 페이지에 펜 자국이 있으면 보통 Handwriting Eraser( 손글씨 제거 )로, 스캔에 오버레이 스탬프나 코너 로고가 남으면 AI Watermark Remover( AI 워터마크 제거 )로 이어갑니다.',
      '깨끗한 문서 사진은 프로젝트가 결국 생성 커버나 프로모 비주얼을 필요로 할 때 Seedream, FLUX, GPT Image로 하류 재사용도 쉬워집니다.'
    ],
    compareIntro: '기울어진 스캔은 Image Crop & Dewarp( 문서 보정 )부터 시작하고 Handwriting Eraser( 손글씨 제거 )와 AI Watermark Remover( AI 워터마크 제거 )를 쓴 뒤 OCR, 아카이브, Seedream, FLUX, GPT Image 이미지 생성 전에 처리하세요.',
    toolFaq: [
      { q: '스캔 문서를 자동 자르고 기울기를 보정하려면?', a: '네 모서리가 보이는 선명한 JPG, PNG, WebP를 올리고 책상 배경을 자른 뒤 기울어진 글줄을 바로잡으세요.' },
      { q: '온라인에서 문서 사진을 바로잡을 수 있나요?', a: '예. 기울어진 스캔은 기울기 보정, 비스듬히 촬영한 경우에는 원근 보정을 사용합니다.' },
      { q: '브라우저에서 휘어진 책 페이지를 보정할 수 있나요?', a: '예. 제본부 곡면이나 말린 종이는 곡면 보정을 사용하세요. 단순 기울기 보정과는 다릅니다.' },
      { q: 'OCR 전에 문서 원근을 고칠 도구는?', a: '먼저 Image Crop & Dewarp. 페이지에 펜 자국이나 스탬프가 남으면 Handwriting Eraser나 AI Watermark Remover로 이어가세요.' },
      { q: '문서 사진의 원근 왜곡은 어떻게 고치나요?', a: '네 모서리가 모두 보이게 한 뒤 원근 보정을 실행하세요. 반사나 그림자가 가장자리를 가리면 고른 조명에서 다시 촬영합니다.' },
      { q: '자동 자르기에서 페이지 가장자리가 숨겨지면 어떻게 고치나요?', a: '모든 모서리가 보이도록 다시 찍고 반사를 줄인 뒤 OCR이나 손글씨 정리 전에 다시 자르세요.' }
    ]
  }
}, bgPack.bodies, pcPack.bodies)

var hub = createHubLocale({
  locale: 'ko',
  articleBodies: ARTICLE_BODIES,
  categories: [
    { key: 'all', label: '전체 글', description: 'AI 이미지 모델, 이미지 도구, 프롬프트 팁, 대안, 실전 튜토리얼.' },
    { key: 'reviews', label: '리뷰', description: 'Seedream, FLUX, Midjourney, GPT Image, Qwen, Z Image, Stable Diffusion 등 AI 이미지 모델 리뷰.' },
    { key: 'how-to-guides', label: '사용 방법', description: 'AI 워터마크 제거, 배경 제거, 손글씨 지우기, 문서 사진 보정 등의 사용 가이드.' },
    { key: 'alternatives', label: '대안', description: 'Midjourney 대안, 온라인 Stable Diffusion 대안 등 비교와 선택 가이드.' },
    { key: 'ai-model-insights', label: 'AI 모델 인사이트', description: '최신 AI 모델의 성능, 컨텍스트, 도구, 비용, 활용 사례와 실제 한계를 자세히 분석합니다.' },
    { key: 'prompt-guides', label: '프롬프트 가이드', description: '텍스트 포스터, 쇼핑몰 이미지, SNS 커버, 제품 이미지용 프롬프트 작성법.' }
  ],
  articles: Object.assign({}, {
    'seedream-ai-image-generator-review': { title: 'Seedream 5 리뷰: 이커머스 제품 이미지와 라이프스타일 포스터 테스트', excerpt: 'Amazon 메인 이미지, Shopify 배너, eBay 제품 이미지, Instagram 제품 게시물에서 Seedream 5를 실사용 기준으로 검토합니다.', target: { label: 'Seedream 5 사용하기' } },
    'flux-ai-image-generator-review': { title: 'FLUX.2 리뷰: 제품 사진과 광고 이미지, 버전 선택법', excerpt: '제품 사진, 광고 비주얼, 상업용 이미지에서 FLUX.2를 테스트하고 다른 모델과의 선택 기준을 정리합니다.', target: { label: 'FLUX.2 열기' } },
    'midjourney-alternative-online': { title: 'Midjourney 대안: Discord 없이 쓰는 온라인 이미지 도구 5가지', excerpt: 'Discord 없이 브라우저에서 제품 이미지, 아트워크, 포스터, 상업용 비주얼을 만드는 Midjourney 대안을 비교합니다.', target: { label: 'Midjourney 온라인 사용' } },
    'gpt-image-generator-guide': { title: 'GPT Image 프롬프트 가이드: 텍스트 포스터와 제품 장점 이미지', excerpt: '읽기 쉬운 포스터 문구, 쇼핑몰 장점 이미지, SNS 커버, 브랜드 비주얼을 위한 GPT Image 프롬프트 작성법.', target: { label: 'GPT Image 열기' } },
    'qwen-image-generator-review': { title: 'Qwen Image 2.0 Pro 리뷰: 마케팅 포스터와 제품 이미지', excerpt: 'Qwen Image 2.0 Pro를 포스터, 제품 이미지, 프롬프트 반영, 상업 워크플로 기준으로 검토합니다.', target: { label: 'Qwen Image 사용하기' } },
    'z-image-ai-generator-review': { title: 'Z Image Turbo 리뷰: 빠른 광고 이미지와 소셜 비주얼', excerpt: 'Z Image Turbo를 빠른 광고 콘셉트, SNS 비주얼, 제품 장면, 가벼운 상업 이미지 생성에 사용해 봅니다.', target: { label: 'Z Image Turbo 사용하기' } },
    'stable-diffusion-online-generator': { title: 'Stable Diffusion 온라인 대안: 로컬 설치 없이 SD 3.5 사용하기', excerpt: '모델 설치, GPU 관리, 로컬 환경 구축 없이 Stable Diffusion 스타일 이미지를 온라인에서 만드는 방법.', target: { label: 'Stable Diffusion 열기' } },
    'ai-watermark-remover-online': { title: 'AI 워터마크 제거 사용법: 로고와 표시를 온라인으로 제거', excerpt: '이미지의 로고, 워터마크, 겹쳐진 표시를 온라인으로 제거하는 단계와 결과 확인 팁.', target: { label: '워터마크 제거 열기' } },
    'handwriting-eraser-online': { title: 'AI 손글씨 제거: 시험지 답안과 문서 메모를 온라인으로 삭제', excerpt: '인쇄 내용은 유지하면서 워크시트, 문서, 스캔 이미지의 손글씨 흔적을 AI로 제거하는 방법.', target: { label: '손글씨 제거 열기' } },
    'image-crop-dewarp-online': { title: 'AI 문서 자르기와 왜곡 보정: 기울기, 그림자, 원근 수정', excerpt: '문서 사진의 가장자리 자르기, 페이지 펴기, 그림자 완화, 원근 왜곡 보정을 온라인으로 처리합니다.', target: { label: '문서 보정 열기' } }
  }, bgPack.articles, pcPack.articles),
  text: {
    home: '홈',
    blog: '블로그',
    allArticles: '전체 글',
    featuredReading: '추천 글',
    featureEntry: '무료 체험',
    aiImageModels: 'AI 이미지 모델',
    aiImageTools: 'AI 이미지 도구',
    categoryNavLabel: '블로그 카테고리',
    searchLabel: '글 검색',
    searchPlaceholder: '모델, 도구, 프롬프트 또는 사용 장면 검색',
    searchButton: '검색',
    clearButton: '지우기',
    popularSearches: '인기 검색어:',
    readArticle: '본문 보기',
    viewAllArticles: '전체 글 보기',
    previousPage: '이전',
    nextPage: '다음',
    allPageTitle: 'AI 이미지 모델 및 도구 블로그',
    homeSectionTitle: 'AI 이미지 모델 및 도구 블로그',
    homeSectionDescription: 'Seedream, FLUX, Midjourney, GPT Image, Qwen, Z Image, Stable Diffusion 및 이미지 도구 리뷰와 실전 가이드.',
    categoryTitleSuffix: ': AI 이미지 생성 및 편집 가이드',
    defaultDescription: 'AI 이미지 생성기, 이미지 도구, 모델 리뷰, 대안, 프롬프트 워크플로를 빠르게 찾는 Miral 가이드.',
    metaTitleAll: 'AI 이미지 생성 블로그: 모델 리뷰, 프롬프트, 이미지 도구 가이드 | Miral',
    viewAllBlog: 'AI 블로그 전체 보기',
    inArticleLabel: '이 글에서',
    quickJump: '빠른 이동',
    promptExample: '프롬프트 예시',
    copyPrompt: '프롬프트 복사',
    copied: '복사됨',
    pros: '장점',
    cons: '단점',
    relatedTitle: '함께 보면 좋은 글',
    tocTitle: '목차',
    useNow: '지금 사용',
    notFoundTitle: '글을 찾을 수 없음',
    backToBlog: '블로그로 돌아가기',
    collapse: '접기',
    expandMore: '더 보기',
    relatedGuidesTitle: '관련 가이드'
  }
})

module.exports = hub
